import $ from "jquery";

// import Swiper JS
import Swiper, { Navigation, Pagination, Autoplay } from '/node_modules/swiper';
// configure Swiper to use modules
Swiper.use([Navigation, Pagination, Autoplay]);

// import Swiper and modules styles


$(function () {

    $.fn.sliderAcfCoach = function () {

        new Swiper(this[0], {
            slidesPerView: 1,
            spaceBetween: 5,
            loop: true,
            autoplay: {
                delay: 5000,
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            navigation: {
                nextEl: ".swiper-next",
                prevEl: ".swiper-prev",
            },
            breakpoints: {
                992: {
                    slidesPerView: 3,
                    spaceBetween: 0
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 0
                },
            },
        });
    
    };

});